export default {"src":"/_next/static/image/public/images/ic_download_invoice.1edaa0a274eb0606e1032c1c28a6b616.svg","height":20,"width":21};